var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('h1',[_c('BaseIcon',{attrs:{"name":"user"}}),_vm._v("\n      "+_vm._s(_vm.user.name)+" Profile\n    ")],1),_c('pre',[_vm._v(_vm._s(_vm.user))]),_c('BaseLink',{attrs:{"name":"resetPassword"}},[_vm._v("Reset Password")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }